import { createSlice } from "@reduxjs/toolkit";
const initialValues = {
  traineeDetails: "",
  traineeStatus: "",
  classRequestId: null,
  classRosterId: null,
};

const bulkEditStoreSlice = createSlice({
  name: "bulkEditStore",
  initialState: initialValues,
  reducers: {
    updateTraineeDetails(state, action) {
      state.traineeDetails = action.payload;
    },
    updateStatusDropdownDetails(state, action) {
      state.statusDropdownDetails = action.payload;
    },
    updateTraineeStatus(state, action) {
      state.traineeStatus = action.payload;
    },
    resetTraineeDetails(state) {
      state.traineeDetails = "";
    },
    setPreviousTabName(state, action) {
      state.previousTabName = action.payload;
    },
    setAttendanceData(state, action) {
      state.storedAttendanceData = action.payload;
    },
    setAttendanceAllData(state, action) {
      state.storedAttendanceAllData = action.payload;
    },
    setEmployeeData(state, action) {
      state.storedEmployeeData = action.payload;
    },
    setEmployeeAllData(state, action) {
      state.storedEmployeeAllData = action.payload;
    },
    setMilestoneData(state, action) {
      state.storedMilestoneData = action.payload;
    },
    setMilestoneAllData(state, action) {
      state.storedMilestoneAllData = action.payload;
    },
    setEmployeeEquipmentData(state, action) {
      state.storedEmployeeEquipmentData = action.payload;
    },
    setEmployeeEquipmentAllData(state, action) {
      state.storedEmployeeEquipmentAllData = action.payload;
    },
    setEmployeeTicketData(state, action) {
      state.storedEmployeeTicketData = action.payload;
    },
    setEmployeeTicketAllData(state, action) {
      state.storedEmployeeTicketAllData = action.payload;
    },
    setClassData(state, action) {
      state.storedClassData = action.payload;
    },
    setClassAllData(state, action) {
      state.storedClassAllData = action.payload;
    },
    setStatusOverrideData(state, action) {
      state.storedStatusOverrideData = action.payload;
    },
    setStatusOverrideAllData(state, action) {
      state.storedStatusOverrideAllData = action.payload;
    },
    setAccData(state, action) {
      state.storedAccData = action.payload;
    },
    setAccAllData(state, action) {
      state.storedAccAllData = action.payload;
    },
    setTciData(state, action) {
      state.storedTciData = action.payload;
    },
    setTciAllData(state, action) {
      state.storedTciAllData = action.payload;
    },
    setProductTrainingData(state, action) {
      state.storedProductTrainingData = action.payload;
    },
    setProductTrainingAllData(state, action) {
      state.storedProductTrainingAllData = action.payload;
    },
    setTtfData(state, action) {
      state.storedTtfData = action.payload;
    },
    setTtfAllData(state, action) {
      state.storedTtfAllData = action.payload;
    },
    setTtdData(state, action) {
      state.storedTtdData = action.payload;
    },
    setTtdAllData(state, action) {
      state.storedTtdAllData = action.payload;
    },
    setStatusDispositionsData(state, action) {
      state.storedStatusDispositionData = action.payload;
    },
    setStatusDispositionAllData(state, action) {
      state.storedStatusDispositionAllData = action.payload;
    },
    setClassRequestId(state, action) {
      state.classRequestId = action.payload;
    },
    setClassRosterId(state, action) {
      state.classRosterId = action.payload;
    },
  },
});

export const bulkEditStoreAction = bulkEditStoreSlice.actions;

export default bulkEditStoreSlice.reducer;
